// 吃瓜在线 - 今日热点聚合站模拟数据（静态展示用）

export interface RankItem {
  id: number;
  tag: "爆" | "热" | "新";
  title: string;
  heatText: string;
  heatNum: number;
  cat: string;
  trend: "up" | "down" | "flat";
}

export const hotRank: RankItem[] = [
  { id: 1, tag: "爆", title: "国产动画电影刷新影史纪录，单日票房再度登顶", heatText: "9862万", heatNum: 98, cat: "影视娱乐", trend: "up" },
  { id: 2, tag: "爆", title: "顶流歌手巡演门票秒空，二手平台转售价翻三倍", heatText: "8124万", heatNum: 84, cat: "音乐现场", trend: "up" },
  { id: 3, tag: "热", title: "新剧《长风渡口》首播口碑两极，编剧深夜回应争议", heatText: "7641万", heatNum: 79, cat: "影视娱乐", trend: "up" },
  { id: 4, tag: "热", title: "年度金曲盛典今晚揭晓，全网网友疯狂押注歌王", heatText: "6980万", heatNum: 72, cat: "音乐现场", trend: "flat" },
  { id: 5, tag: "热", title: "老牌乐队宣布重组，解散三十年后再度合体开唱", heatText: "6277万", heatNum: 66, cat: "明星动态", trend: "up" },
  { id: 6, tag: "热", title: "电影节红毯造型大盘点：谁赢麻了谁翻车了", heatText: "5513万", heatNum: 58, cat: "明星动态", trend: "down" },
  { id: 7, tag: "新", title: "奥运冠军官宣新工作，退役后转型再引热议", heatText: "4896万", heatNum: 52, cat: "体坛竞技", trend: "up" },
  { id: 8, tag: "新", title: "某地文旅局长变装宣传出圈，评论区直接笑疯", heatText: "4210万", heatNum: 45, cat: "社会奇闻", trend: "up" },
  { id: 9, tag: "新", title: "主播跨界挑战大银幕，首日票房惨淡引全网劝退", heatText: "3568万", heatNum: 38, cat: "社会奇闻", trend: "down" },
  { id: 10, tag: "热", title: "高校食堂推出“盲盒打饭”，学生排队求同款", heatText: "2874万", heatNum: 31, cat: "生活百态", trend: "flat" },
];

export const hotPreview: RankItem[] = [
  { id: 1, tag: "爆", title: "国产动画电影刷新影史纪录，单日票房再度登顶", heatText: "9862万", heatNum: 98, cat: "影视娱乐", trend: "up" },
  { id: 2, tag: "爆", title: "顶流歌手巡演门票秒空，二手平台转售价翻三倍", heatText: "8124万", heatNum: 84, cat: "音乐现场", trend: "up" },
  { id: 3, tag: "爆", title: "年度金曲盛典今晚揭晓，全网网友疯狂押注歌王", heatText: "6980万", heatNum: 72, cat: "音乐现场", trend: "flat" },
];

export interface BigNews {
  id: number;
  title: string;
  summary: string;
  img: string;
  cat: string;
  time: string;
  read: string;
  comment: string;
}

export const bigNews: BigNews[] = [
  {
    id: 1,
    title: "《长风渡口》首播即爆：观众为“三观”吵上热搜",
    summary: "上线不到两小时便冲上热度榜首，关于剧情设定的争议让不同立场的观众各执一词，编剧深夜长文回应。",
    img: "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20scene%20of%20a%20mountain%20town%20by%20a%20misty%20river%20at%20dusk%2C%20warm%20amber%20and%20teal%20tones%2C%20cinematic%20lighting%2C%20editorial%20film%20still%20composition%2C%20atmospheric%20and%20high%20detail&width=800&height=560&seq=big-news-01&orientation=landscape",
    cat: "影视娱乐",
    time: "12 分钟前",
    read: "8.4万",
    comment: "1.2万",
  },
  {
    id: 2,
    title: "金曲盛典回归线下：路透阵容一出，歌迷集体押题",
    summary: "阔别多年的实体颁奖礼即将落地，流出的嘉宾名单点燃讨论，谁是最佳男女歌手成为全网押注焦点。",
    img: "https://readdy.ai/api/search-image?query=elegant%20music%20awards%20ceremony%20stage%20with%20golden%20lighting%20and%20spotlights%2C%20crowd%20of%20fans%20holding%20glowing%20phones%2C%20warm%20celebratory%20atmosphere%2C%20editorial%20event%20photography%2C%20cinematic%20depth%20of%20field&width=800&height=560&seq=big-news-02&orientation=landscape",
    cat: "音乐现场",
    time: "26 分钟前",
    read: "6.7万",
    comment: "9360",
  },
  {
    id: 3,
    title: "老牌乐队官宣重组：解散三十年后，青春突然回来了",
    summary: "官方发布重逢海报，四位初代成员悉数归位，阔别多年的全国巡演与精选专辑同步提上日程。",
    img: "https://readdy.ai/api/search-image?query=retro%20rock%20band%20silhouette%20under%20warm%20stage%20lights%20in%20a%20dark%20concert%20hall%2C%20vintage%20guitars%2C%20nostalgic%20atmosphere%2C%20editorial%20music%20photography%2C%20high%20contrast%20and%20emotional&width=800&height=560&seq=big-news-03&orientation=landscape",
    cat: "明星动态",
    time: "41 分钟前",
    read: "5.3万",
    comment: "7800",
  },
  {
    id: 4,
    title: "某动画电影爆冷登顶：主创团队连夜回应续作计划",
    summary: "在强片环伺之下逆势崛起，精准戳中观众情绪，导演接受专访时透露续作已在剧本阶段。",
    img: "https://readdy.ai/api/search-image?query=colorful%20hand%20drawn%20animation%20film%20frames%20with%20soft%20studio%20workspace%20and%20sketch%20tablets%2C%20warm%20creative%20lighting%2C%20playful%20yet%20refined%2C%20editorial%20behind%20the%20scenes%20composition&width=800&height=560&seq=big-news-04&orientation=landscape",
    cat: "影视娱乐",
    time: "1 小时前",
    read: "4.9万",
    comment: "6020",
  },
  {
    id: 5,
    title: "文旅局长变装出圈：一人分饰多角，把家乡拍成大片",
    summary: "一支三分钟的创意短片引爆全网，评论区喊话“求更多系列”，当地景区搜索量同步暴涨。",
    img: "https://readdy.ai/api/search-image?query=beautiful%20ancient%20chinese%20town%20with%20red%20lanterns%20at%20dusk%20and%20misty%20mountains%2C%20traditional%20architecture%2C%20warm%20golden%20light%2C%20travel%20promotion%20visual%2C%20editorial%20landscape%20photography&width=800&height=560&seq=big-news-05&orientation=landscape",
    cat: "社会奇闻",
    time: "1 小时前",
    read: "4.2万",
    comment: "5300",
  },
  {
    id: 6,
    title: "高校食堂“盲盒打饭”走红：未知的惊喜成了下饭神器",
    summary: "不看菜名随机出餐的新玩法让食堂排起长队，网友纷纷晒出自己的“开盲盒”结果求同款。",
    img: "https://readdy.ai/api/search-image?query=colorful%20student%20cafeteria%20food%20trays%20with%20assorted%20dishes%20on%20a%20wooden%20table%2C%20bright%20fresh%20natural%20light%2C%20lively%20campus%20mood%2C%20editorial%20food%20photography%2C%20warm%20tones&width=800&height=560&seq=big-news-06&orientation=landscape",
    cat: "生活百态",
    time: "2 小时前",
    read: "3.6万",
    comment: "4100",
  },
];

export const categories: { key: string; name: string; icon: string }[] = [
  { key: "all", name: "全部", icon: "ri-flashlight-line" },
  { key: "star", name: "明星动态", icon: "ri-user-star-line" },
  { key: "film", name: "影视娱乐", icon: "ri-clapperboard-line" },
  { key: "music", name: "音乐现场", icon: "ri-mic-line" },
  { key: "sport", name: "体坛竞技", icon: "ri-trophy-line" },
  { key: "society", name: "社会奇闻", icon: "ri-earth-line" },
  { key: "life", name: "生活百态", icon: "ri-cup-line" },
];

export interface FeedItem {
  id: number;
  cat: string;
  title: string;
  time: string;
  read: string;
  comment: string;
}

export const feed: FeedItem[] = [
  { id: 1, cat: "film", title: "《长风渡口》首播即爆，编剧深夜长文回应三观争议", time: "12分钟前", read: "8.4万", comment: "1.2万" },
  { id: 2, cat: "music", title: "金曲盛典回归线下，全阵容路透点燃歌迷押题大战", time: "26分钟前", read: "6.7万", comment: "9360" },
  { id: 3, cat: "star", title: "老牌乐队官宣重组，解散三十年初代成员悉数归位", time: "41分钟前", read: "5.3万", comment: "7800" },
  { id: 4, cat: "society", title: "文旅局长变装宣传家乡出圈，景区搜索量同步暴涨", time: "1小时前", read: "4.2万", comment: "5300" },
  { id: 5, cat: "sport", title: "奥运冠军退役转型再就业，首份新岗位引发全网祝贺", time: "1小时前", read: "4.0万", comment: "6100" },
  { id: 6, cat: "life", title: "高校食堂推出盲盒打饭，学生排队只为一顿惊喜", time: "2小时前", read: "3.6万", comment: "4100" },
  { id: 7, cat: "star", title: "电影节红毯造型大盘点：有人赢麻有人被群嘲", time: "2小时前", read: "5.1万", comment: "1.0万" },
  { id: 8, cat: "film", title: "某动画电影爆冷登顶，主创回应续作已进剧本阶段", time: "3小时前", read: "4.9万", comment: "6020" },
  { id: 9, cat: "music", title: "顶流歌手巡演门票秒空，转售价翻三倍引发热议", time: "3小时前", read: "8.1万", comment: "1.4万" },
  { id: 10, cat: "society", title: "主播跨界演电影首日扑街，网友劝其专注本行", time: "4小时前", read: "3.5万", comment: "2900" },
  { id: 11, cat: "life", title: "奶茶品牌推出“吃瓜”联名款，门店排队爆满", time: "5小时前", read: "2.8万", comment: "3400" },
  { id: 12, cat: "sport", title: "全民健身日话题刷屏，各地球友晒出花式锻炼", time: "6小时前", read: "2.2万", comment: "1800" },
];

export interface Topic {
  id: number;
  tag: string;
  title: string;
  desc: string;
  img: string;
  read: string;
}

export const topics: Topic[] = [
  {
    id: 1,
    tag: "深度解读",
    title: "当“吃瓜”成为社交货币：我们为什么停不下来刷热搜",
    desc: "从“有瓜同吃”到“无瓜不谈”，一条热点的传播早已不只是消遣。本文试着拆解热搜背后的情绪、身份与圈层逻辑。",
    img: "https://readdy.ai/api/search-image?query=modern%20urban%20crowd%20looking%20down%20at%20glowing%20smartphone%20screens%20at%20night%2C%20bokeh%20city%20lights%2C%20social%20media%20obsession%20concept%2C%20warm%20and%20cool%20contrast%2C%20editorial%20documentary%20style%2C%20high%20detail&width=1200&height=675&seq=topic-01&orientation=landscape",
    read: "26.3万",
  },
  {
    id: 2,
    tag: "热点复盘",
    title: "从热搜到热议：一条“瓜”如何在24小时内发酵",
    desc: "从首发爆料、多平台搬运、大号下场，到当事人回应与舆论反转——我们梳理了信息传播的完整时间轴与关键节点。",
    img: "https://readdy.ai/api/search-image?query=abstract%20timeline%20infographic%20with%20glowing%20nodes%20and%20connecting%20lines%20over%20a%20dark%20textured%20background%2C%20warm%20amber%20highlights%2C%20data%20journalism%20aesthetic%2C%20modern%20and%20clean&width=1200&height=675&seq=topic-02&orientation=landscape",
    read: "19.7万",
  },
  {
    id: 3,
    tag: "年度盘点",
    title: "盘点今年最出圈的十件新鲜事，谁是真正的“顶流”",
    desc: "站在年尾回望，从出圈神曲到国民级话题，我们用热度曲线排出本年度最具讨论度的十件事，看看你错过了几个。",
    img: "https://readdy.ai/api/search-image?query=vibrant%20collage%20of%20glowing%20trending%20keywords%20and%20hash%20tags%20floating%20in%20space%2C%20warm%20coral%20and%20teal%20gradient%20background%2C%20modern%20editorial%20graphic%2C%20playful%20and%20energetic&width=1200&height=675&seq=topic-03&orientation=landscape",
    read: "31.2万",
  },
];

export interface Faq {
  q: string;
  a: string;
}

export const faqs: Faq[] = [
  {
    q: "吃瓜在线的热点多久更新一次？",
    a: "我们全天候跟踪全网热榜与各平台讨论热度，滚动整理“今日大瓜”“今日热议”与“今日新鲜事”三大板块。重要突发会在第一时间置顶更新，日常内容通常每 10 到 30 分钟刷新一次。",
  },
  {
    q: "你们的内容来源可靠吗？",
    a: "所有内容均汇总自公开平台的热搜与公开报道，并标注信息形态与讨论热度。我们强调“跟进、核实、再传播”，对尚无定论的传闻会明确提示，尽量不放大未经证实的消息。",
  },
  {
    q: "我能投稿或提供线索吗？",
    a: "非常欢迎。你可以使用页面底部的“我要爆料”表单提交线索，也可在相关话题下留言。编辑部会优先跟进信息完整、有公开佐证的投稿，一经采用我们会联系你确认细节。",
  },
  {
    q: "为什么有些话题没有展开报道？",
    a: "吃瓜在线定位是“新鲜事速览”，优先帮助大家快速掌握今天全网在聊什么。对值得深挖的话题，我们会升级为“深度专题”单独成文；轻量话题则以一句话热榜的形式呈现，避免信息过载。",
  },
  {
    q: "如何根据兴趣只看我关心的栏目？",
    a: "在“分类速览”区可以按明星动态、影视娱乐、音乐现场、体坛竞技、社会奇闻、生活百态等栏目一键筛选，只看你感兴趣的方向。热榜与精选仍会展示全站最热内容。",
  },
  {
    q: "吃瓜在线支持手机访问吗？",
    a: "支持。站点采用响应式设计，电脑、平板与手机都能获得流畅体验；移动端导航可折叠，底部一键返回顶部，随时随地吃上最新鲜的瓜。",
  },
];

export interface Principle {
  icon: string;
  title: string;
  desc: string;
}

export const principles: Principle[] = [
  { icon: "ri-eye-line", title: "看得全", desc: "聚合全网热搜与多平台热议，一次刷完今天值得讨论的所有新鲜事。" },
  { icon: "ri-timer-line", title: "跟得快", desc: "编辑部全天滚动跟进突发，第一时间把最热的大瓜摆到你面前。" },
  { icon: "ri-focus-3-line", title: "说得清", desc: "只做事实梳理与热度呈现，对传闻保留克制，不让情绪替你下结论。" },
  { icon: "ri-group-line", title: "聊得开", desc: "不同兴趣栏目自由切换，评论区友善吃瓜，理性讨论也值得被听见。" },
];